import { Box, Typography } from "@mui/material";

import type { FormControl } from "@thalamos/haven-common";

type ChoiceOption = Extract<FormControl, { kind: "choice" }>["options"][number];

/** The longer meaning beneath a title, where one is declared. */
export const Description = ({ text }: { text: string | undefined }) =>
  // A span, because it sits inside a label, which may hold only phrasing
  // content.
  text === undefined ? null : (
    <Typography
      variant="body2"
      color="text.secondary"
      component="span"
      display="block"
    >
      {text}
    </Typography>
  );

/** What a choice's option says: its score, its title and, beneath, what it means. */
export const ChoiceOptionLabel = ({ option }: { option: ChoiceOption }) => (
  <Box component="span">
    {/* A numeric value is shown as a score beside its title; a string value
        is only an identifier, so it is not shown. */}
    {typeof option.value === "number" ? (
      <Typography component="span" sx={{ fontWeight: "bold", mr: 1 }}>
        {option.value}
      </Typography>
    ) : null}{" "}
    {option.title.text}
    <Description text={option.description?.text} />
  </Box>
);
